import { combineReducers } from 'redux-immutable'
import { connectRouter } from 'connected-react-router'
import { createHashHistory } from 'history'

import user from './reducer/user'
import i18n from './reducer/i18n'
import displayMenu from './reducer/displayMenu'
import common from './reducer/common'

export const history = createHashHistory()

/**
 * 合并reducer逻辑，集成了immutable
 */
const reducer = combineReducers<any>({
  router: connectRouter<unknown>(history),
  displayMenu,
  user,
  i18n,
  common
})

export default reducer
